import _Vue from 'vue'
import { ProductCategoryService, CompanyService } from '@/firestore'


const serviceSingletonsPlugin = {
  install(vue: typeof _Vue) {

    const services = {
      productCategoryService: null,
      companyService: null
    }

    Object.defineProperties(vue.prototype, {
      $productCategoryService: {
        get() {
          if (!services.productCategoryService) {
            services.productCategoryService = this.$firebase.then(
              (firebase: any) => new ProductCategoryService(firebase.firestore())
            )
          }

          return services.productCategoryService
        }
      },
      $companyService: {
        get() {
          if (!services.companyService) {
            services.companyService = this.$firebase.then(
              (firebase: any) => new CompanyService(firebase.firestore())
            )
          }

          return services.companyService
        }
      }
    })
  }
}

export default serviceSingletonsPlugin

declare module 'vue/types/vue' {
  interface Vue {
    $productCategoryService: Promise<ProductCategoryService>;
    $companyService: Promise<CompanyService>;
  }
}
